import { query } from '@angular/animations';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Post, Link, IFile, Resource } from '../../../_models';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { ResoursesService } from 'src/app/_services/academic/resourses.service';

@Component({
  selector: 'app-upload-control',
  templateUrl: './upload-control.component.html',
  styleUrls: ['./upload-control.component.scss']
})
export class UploadControlComponent implements OnInit {
  @Input('UploadFieldId') UploadFieldId: string;
  @Input('isSingle') isSingle: boolean = true;
  @Input('acceptedFilter') acceptedFilter: string = '*';
  @Output("outFiles") outFiles = new EventEmitter();

  fileable: boolean = false;
  fileList: IFile[];
  public upLoader: FileUploader = new FileUploader({ url: '' });
  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }
  updateImage() {
    this.fileList = [];
    for (let i = 0; i < this.upLoader.queue.length; i++) {
      this.getFileurl(this.upLoader.queue[i], 'img' + i);
    }
  }
  constructor(private resorceservice: ResoursesService) {
    const that = this;
    this.upLoader.onAfterAddingFile = function (v) {
      that.outFiles.emit(that.upLoader);
      if (that.upLoader.queue.length > 1 && that.isSingle)
        that.upLoader.queue.splice(0, 1);
      console.log(that.upLoader);
      that.updateImage();
    };
  }

  ngOnInit() {
  }

  openUploadDialog() {
    document.getElementById(this.UploadFieldId).click();
  }
  getFileurl(file: FileItem, name: string) {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      //   console.log(event.target.result)

      const arr = file.file.name.split('.');
      const ext = arr[arr.length - 1];
      if (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gif' || ext === 'pmp') {
        const f: IFile = {
          name: name,
          path: event.target.result,
          size: this.formatSizeUnits(file.file.size),
          type: ext
        };
        document.getElementById(name).setAttribute('src', event.target.result);
        this.fileList.push(f);
      } else {
        const item: Resource = {
          name: '',
          discription: '',
          id: 1,
          file: {
            name: '',
            path: '',
            size: '',
            type: ext
          }
        };
        const f: IFile = {
          name: name,
          path: this.resorceservice.getIconByType(item),
          size: this.formatSizeUnits(file.file.size),
          type: ext
        };
        document.getElementById(name).setAttribute('src', f.path);
        this.fileList.push(f);
      }
    };
    reader.readAsDataURL(file._file);
  }

  formatSizeUnits(bytes) {
    if (bytes >= 1073741824) bytes = (bytes / 1073741824).toFixed(2) + ' GB';
    else if (bytes >= 1048576) bytes = (bytes / 1048576).toFixed(2) + ' MB';
    else if (bytes >= 1024) bytes = (bytes / 1024).toFixed(2) + ' KB';
    else if (bytes > 1) bytes = bytes + ' bytes';
    else if (bytes === 1) bytes = bytes + ' byte';
    else bytes = '0 bytes';
    return bytes;
  }
  RemoveFile(name: String, event) {
    event.preventDefault();
    event.stopPropagation();
    const i = name.split('img')[1];
    const l = Number(i);
    this.upLoader.queue.splice(l, 1);
    this.updateImage();
    this.outFiles.emit(this.upLoader);
    if(this.upLoader.queue.length < 1)
    {
      let myInput = document.getElementById(this.UploadFieldId) as HTMLInputElement; 
      myInput.value = '';
    }
  }
}
